<div class="flex flex-col items-center justify-center gap-3 p-6">
  <div class="mb-6.5 w-100 flex flex-row items-center">
    <span class="title flex-1 text-center">Opciones de portada</span>
    <ion-icon class="cursor-pointer" icon="assets/icon/cross.svg" (click)="modalController.dismiss()"></ion-icon>
  </div>
  <div class="scrolled-container">
    <div *ngIf="!fileSettings.coverLaminated" class="section w-100 flex flex-col items-start">
      <span class="section_title">Grosor del papel:</span>
      <div class="w-100 flex flex-row flex-wrap gap-2">
        <ng-container *ngFor="let option of paperOptions">
          <div
            *ngIf="option.hideCondition"
            class="flex flex-1"
            tooltipClass="warning-tooltip"
            [tooltip]="getTooltip(option)"
          >
            <ion-button
              class="option paperWeight flex-1"
              fill="clear"
              [class.selected]="paperWeight === option.value"
              (click)="paperWeight = option.value"
              [disabled]="isDisabled(option)"
            >
              <div class="flex flex-col gap-2">
                <span class="paperWeight_title">{{ option.title }}</span>
                <span class="paperWeight_subtitle">{{ option.subtitle }}</span>
              </div>
            </ion-button>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="videoList$ | async as videoList" class="section w-100 flex flex-col items-start">
      <span class="section_title">Tipo de portada:</span>
      <div class="coverOptions w-100 flex flex-col">
        <ion-radio-group [value]="currentCoverType.id" class="w-100 flex flex-col gap-2">
          <ion-radio
            *ngFor="let setting of coverSettings"
            mode="md"
            labelPlacement="start"
            justify="space-between"
            [value]="setting.value.id"
            class="option flex"
            [class.selected]="coverOption.id === setting.value.id"
            (click)="coverOption = setting.value"
          >
            <div class="flex flex-row gap-4">
              <div class="w-100 flex flex-col gap-2 md:flex-row">
                <img class="coverTypeIcon" [src]="fileService.getCoverTypeImage(setting.value, fileSettings)" alt="" />
                <div class="flex flex-col">
                  <div class="flex flex-row flex-wrap items-center justify-between">
                    <div class="flex flex-row flex-wrap gap-x-2">
                      <span class="coverOption_title text-wrap">{{
                        setting.title + (!setting.value.twoSided && fileSettings.twoSided ? ', una cara' : '')
                      }}</span>
                      <span
                        *ngIf="fileService.getDefaultCoverType(fileSettings, fileSettings).id === setting.value.id"
                        class="default_annotation"
                        >(Opción por defecto)</span
                      >
                    </div>
                  </div>
                  <div class="flex flex-row flex-wrap gap-3">
                    <span *ngIf="fileSettings.twoSided && setting.value.twoSided" class="title_annotation yellow"
                      >Sin despaginación</span
                    >
                    <span *ngIf="fileSettings.twoSided && !setting.value.twoSided" class="title_annotation pink"
                      >Con despaginación</span
                    >
                    <span *ngIf="fileSettings.twoSided && !setting.value.twoSided" class="title_annotation pink"
                      >Desconfigura tu documento</span
                    >
                  </div>
                  <span class="coverOption_subtitle">{{ subtitles[getCoverTypeFullId(setting.value)] }}</span>
                  <span
                    *ngIf="videoList.length && videoExists(videoList, setting.value)"
                    class="videoLink"
                    (click)="showVideo($event, setting.value)"
                    >Ver vídeo de ejemplo</span
                  >
                </div>
              </div>
            </div>
            <ng-container *ngIf="fileSettings.twoSided && !setting.value.twoSided">
              <ion-icon
                [id]="'alert-info' + setting.value.id"
                class="tooltip-icon"
                src="assets/icon/alert-info.svg"
                (click)="stopPropagation($event)"
              ></ion-icon>
              <ion-popover
                [trigger]="'alert-info' + setting.value.id"
                class="info-popover"
                triggerAction="click"
                showBackdrop="true"
                animated="true"
                arrow="true"
                mode="ios"
              >
                <ng-template>
                  <app-tooltip-info-despagination></app-tooltip-info-despagination>
                </ng-template>
              </ion-popover>
            </ng-container>
          </ion-radio>
        </ion-radio-group>
      </div>
    </div>
  </div>
  <div class="w-100 flex flex-row gap-2">
    <ion-button class="flex flex-1" (click)="modalController.dismiss()" fill="outline" color="dark"
      >Cancelar
    </ion-button>
    <ion-button class="flex flex-1" (click)="saveCoverType()" color="primary">Guardar y continuar</ion-button>
  </div>
</div>
